import React, { useEffect } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FourOhFourError } from '@sm/webassets';

import {
  HomePage,
  CategoriesPage,
  FeaturedPage,
  MostPopularPage,
  RecentlyAddedPage,
  SearchPage,
  MyAppsPage,
  DetailsPage,
} from './pages';

const AppsDirectoryRouter = ({ history }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, [history]);

  return (
    <Switch>
      <Route path="/apps/:appId/preview" render={props => <DetailsPage {...props} preview />} />
      <Route path="/apps/:appId/details" component={DetailsPage} exact />
      <Route path="/apps/my-apps" component={MyAppsPage} exact />
      <Route path="/apps/recently-added" component={RecentlyAddedPage} exact />
      <Route path="/apps/most-popular" component={MostPopularPage} exact />
      <Route path="/apps/featured-apps" component={FeaturedPage} exact />
      <Route path="/apps/search" component={SearchPage} exact />
      <Route path="/apps/categories/:categoryKey" component={CategoriesPage} exact />
      <Route path="/apps" component={HomePage} exact />
      <Route component={FourOhFourError} />
    </Switch>
  );
};

AppsDirectoryRouter.propTypes = {
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(AppsDirectoryRouter);
